import React from 'react';

import { Grid, makeStyles, Typography } from '@material-ui/core';

import CaseActionsArchiveButton from './CaseActionsArchiveButton';
import CaseActionsRadiologyImagesField from './CaseActionsRadiologyImagesField';
import CaseActionsRadiologyReportField from './CaseActionsRadiologyReportField';
import { WorkspaceProductType } from '../../models/Workspace';
import LoadingButton from '../common/LoadingButton';

const useStyles = makeStyles(() => {
  return {
    bypassReportButton: {
      marginTop: '1rem',
    },
    orContainer: {
      alignItems: 'center',
      display: 'flex',
      margin: '30px 0px',
    },
    orLineContainer: {
      borderTop: '1px solid #E7E7E7',
      height: '0px',
      width: '100%',
    },
    orTypography: {
      color: '#999999',
      fontSize: '12px',
      marginBottom: '0px',
      padding: '0px 12px',
    },
    sectionHeader: {
      color: '#172B4D',
      fontSize: '18px',
      fontWeight: 'bold',
      marginBottom: '1rem',
    },
    sectionText: {
      color: '#999999',
      fontSize: '12px',
      marginTop: '1rem',
    },
    submitMediphanyButton: {
      marginTop: '3rem',
    },
    typographySectionDescription: {
      color: '#999999',
      fontSize: '12px',
      marginBottom: '0px',
    },
    typographySectionSubtitle: {
      color: '#172B4D',
      fontSize: '12px',
      fontWeight: 'bold',
      marginBottom: '8px',
      marginTop: '0rem',
    },
  };
});

export default ({
  fileStatus,
  onCaseAction,
  auth,
  isSubmitting$,
  isSubmitting,
  hideFileControls,
  onChangeTitle,
  onRemoveFiles,
  onFileChange,
  onRemoveReport,
  onReportChange,
  caseStudy,
  onOpenRadiologyReportDialog,
  isArchiving$,
  isBypassing$,
  workspace,
  workspaceMainFileType,
  onOpenImageSelectionDialog,
}) => {
  const classes = useStyles();

  const message = `The customer has requested that we access their files on their behalf via ${
    caseStudy.isLawFirmCase && !caseStudy?.caseLinkInfo ? 'material send through email' : 'their online portal'
  }`;

  const submitButtonEnabled =
    (fileStatus.existingStudy && ((fileStatus.uploadedReport && fileStatus.uploadedReport.length > 0) || fileStatus.hasReport)) ||
    (fileStatus.reportUploaded && fileStatus.uploaded && fileStatus.imageCount);

  return (
    <Grid container className="text-left">
      <Grid item xs={12}>
        <Typography className={classes.sectionHeader}>Upload Study</Typography>
        <Typography className={classes.sectionText}>{message}</Typography>
      </Grid>
      <Grid item xs={12}>
        <Typography className={`mt-1 ${classes.typographySectionSubtitle}`}>Upload Files:</Typography>
      </Grid>
      <Grid item xs={12}>
        <CaseActionsRadiologyImagesField
          fileStatus={fileStatus}
          hideFileControls={hideFileControls}
          onChangeTitle={onChangeTitle}
          onRemoveFiles={onRemoveFiles}
          onFileChange={onFileChange}
          shouldSelectAnyStudy={workspaceMainFileType === 'any'}
          onOpenImageSelectionDialog={onOpenImageSelectionDialog}
        />
      </Grid>
      <Grid item xs={12}>
        <CaseActionsRadiologyReportField
          fileStatus={fileStatus}
          onReportChange={onReportChange}
          onOpenRadiologyReportDialog={onOpenRadiologyReportDialog}
          onRemoveReport={onRemoveReport}
          isSubmitting={isSubmitting}
        />
      </Grid>
      <Grid item xs={12}>
        <LoadingButton
          loading$={isSubmitting$}
          disabled={isSubmitting || !submitButtonEnabled}
          variant="contained"
          fullWidth
          component="span"
          onClick={() => onCaseAction('submitClinicUpload')}
          className={classes.submitMediphanyButton}
          color="primary">
          Mark Upload Complete
        </LoadingButton>
      </Grid>

      {workspace?.productType !== WorkspaceProductType.whiteGlove.value && (
        <>
          <Grid item xs={12}>
            <div className={classes.orContainer}>
              <div className={classes.orLineContainer} style={{ flexGrow: 1 }} />
              <Typography className={classes.orTypography}>Or</Typography>
              <div className={classes.orLineContainer} style={{ flexGrow: 1 }} />
            </div>
          </Grid>

          <Grid item xs={12}>
            <Typography className={classes.typographySectionSubtitle}>Bypass Files:</Typography>
            <Typography className={classes.typographySectionDescription}>
              The option should be used bypass the radiology images and report when the blank recorder will be launched
            </Typography>
          </Grid>

          <Grid item xs={12}>
            <LoadingButton
              loading$={isBypassing$}
              variant="contained"
              fullWidth
              component="span"
              onClick={() => onCaseAction('bypassImagesAndReport')}
              className={classes.bypassReportButton}
              color="primary">
              Bypass Images and Report
            </LoadingButton>
          </Grid>
        </>
      )}

      <Grid item xs={12}>
        <div style={{ marginTop: '1rem' }}>
          <CaseActionsArchiveButton fullWidth size="medium" auth={auth} isArchiving$={isArchiving$} onCaseAction={onCaseAction} />
        </div>
      </Grid>
    </Grid>
  );
};
